var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","fill":"currentColor","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }